"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListUsersResponseSchema = exports.AdminContractGetUserResponseSchema = exports.AdminContractListUsersQueryParamsSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const RoleSchema = zod_1.z.enum(['ADMIN', 'STAFF', 'USER']);
const UserSchema = zod_1.z.object({
    role: RoleSchema,
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    phoneNumber: zod_1.z.string(),
});
exports.AdminContractListUsersQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({
    search: zod_1.z.string().optional(),
    sortBy: zod_1.z.string().default('name|asc'),
});
const ImpactHistorySchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    image: zod_1.z.string(),
    quantity: zod_1.z.number(),
    rate: zod_1.z.number(),
    amount: zod_1.z.number(),
    purchaseDate: zod_1.z.string(),
});
const AdminContractUsersSchema = UserSchema.omit({
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    dateOfBirth: true,
}).extend({
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    deletedAt: zod_1.z.string().nullable(),
    dateOfBirth: zod_1.z.string().nullable(),
});
exports.AdminContractGetUserResponseSchema = zod_1.z.object({
    user: AdminContractUsersSchema.extend({
        rank: zod_1.z.string(),
        rankIcon: zod_1.z.string(),
        totalImpact: zod_1.z.number(),
        nextRank: zod_1.z.string().nullable(),
        nextRankImpact: zod_1.z.number().nullable(),
        impactHistories: ImpactHistorySchema.array(),
    }),
});
exports.AdminContractListUsersResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ users: AdminContractUsersSchema.array() });
